/**
 * Space Members Management
 *
 * Thin binding of the shared MembersPanel to the spaces.* member procedures.
 * Used on the space detail page by space owners and admins. The roster keeps
 * the synthetic owner row (Crown badge — UAT F1) that spaces.listMembers
 * returns; all list/role/remove/add UI lives in members/members-panel.tsx.
 */

import { trpc } from '@/trpc/client'
import { MembersPanel } from './members/members-panel'

export function SpaceMembers({ spaceId }: { spaceId: string }) {
	const utils = trpc.useUtils()
	const invalidate = () => utils.spaces.listMembers.invalidate({ spaceId })

	const { data: members, isLoading } = trpc.spaces.listMembers.useQuery(
		{ spaceId },
		{ retry: false },
	)

	// addMember doubles as the role-change mutation (server upserts the row).
	const addMemberMutation = trpc.spaces.addMember.useMutation({ onSuccess: invalidate })
	const removeMemberMutation = trpc.spaces.removeMember.useMutation({ onSuccess: invalidate })

	return (
		<MembersPanel
			copyPrefix="members"
			members={members}
			isLoading={isLoading}
			onAdd={(userId, role) => addMemberMutation.mutateAsync({ spaceId, userId, role })}
			onChangeRole={(userId, role) => addMemberMutation.mutateAsync({ spaceId, userId, role })}
			onRemove={(userId) => removeMemberMutation.mutateAsync({ spaceId, userId })}
		/>
	)
}
